import {
  Button,
  Layout,
  theme,
  Form,
  Input,
  Spin,
  notification,
  Select,
} from "antd";

import React, { useEffect, useCallback, useState } from "react";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
// import FooterDashboard from "../common/FooterDashboard/FooterDashboard";
import AllergensApi from "../common/Apis/AllergensApi";
import DepartmentsApi from "../common/Apis/DepartmentsApi";
import SubtenantApi from "../common/Apis/SubtenantApi";

const EditSubtenants = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const [form] = Form.useForm();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  const [loadings, setLoadings] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");

 
  const getSubTenants = useCallback(() => {
    SubtenantApi.SingleSubtenantsApi(id)
      .then((response) => {
        console.log("response");
        console.log(response);
        form.setFieldsValue({
          subTenantCode: response?.payload?.subTenantCode,
          subTenantName: response?.payload?.subTenantName,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getSubTenants();
  }, []);
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      tenantId: decodedToken?.tenantId,
      subTenantCode: data?.subTenantCode,
      subTenantName: data?.subTenantName,
      // subTenantApiKey: data?.tenantApiKey,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });

    SubtenantApi.PutSubtenant(id, formData)
      .then((response) => {
        console.log(response);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Updated</span>,
          description: "Updated Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });

        return navigate("/sub-tenants");
      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            form={form}
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="subTenantCode"
                    label="Sub Tenant Code"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Sub Tenant Code",
                      },
                    ]}
                  >
                    <Input
                      disabled
                      type="text"
                      placeholder="Sub Tenant Code"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>

                <Col lg={8} md={12}>
                  <Form.Item
                    name="subTenantName"
                    label="Sub Tenant Name"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Sub Tenant Name",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Sub Tenant Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>

              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Update {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default EditSubtenants;
